"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const selectNodeStepsWithIndexes = (sharedZap) => {
    return lodash_1.default.get(sharedZap, 'steps', [])
        .map((step, index) => ({
        step,
        index,
    }))
        .filter(({ step }) => step.type === 'node');
};
exports.default = selectNodeStepsWithIndexes;
